
import {getGamerInformation} from '../api/getGamerInformation';
import {setGetGamerInformationAction} from '../action';

const setGetGamerInformation = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGamerInformation(params);
    
            if (data.status === 'success') {
                dispatch(setGetGamerInformationAction({
                    count_gamer: data.data
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetGamerInformation
}